"use client";

import { useState, useEffect } from "react";

export default function Preloader() {
  const [text, setText] = useState("");
  const [exiting, setExiting] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const fullText = "On ouvre ton placard...";
    let i = 0;

    const typeTimer = setTimeout(() => {
      const interval = setInterval(() => {
        i++;
        setText(fullText.substring(0, i));
        if (i >= fullText.length) clearInterval(interval);
      }, 30);
      return () => clearInterval(interval);
    }, 400);

    const exitTimer = setTimeout(() => {
      setExiting(true);
    }, 2200);

    const hideTimer = setTimeout(() => {
      setHidden(true);
    }, 2900);

    return () => {
      clearTimeout(typeTimer);
      clearTimeout(exitTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  if (hidden) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 10000,
        background: "#FDF6EE",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        transition: "transform 0.7s cubic-bezier(0.76, 0, 0.24, 1)",
        transform: exiting ? "translateY(-100%)" : "translateY(0)",
      }}
    >
      {/* Hanger SVG with pendulum animation */}
      <div
        style={{
          width: 60,
          height: 60,
          transformOrigin: "50% 0%",
          animation: "mkt-pendulum 1.5s ease-in-out infinite",
          transition: "transform 0.4s ease-in",
          transform: exiting ? "scale(0)" : undefined,
        }}
      >
        <svg
          viewBox="0 0 60 60"
          fill="none"
          stroke="#2C2520"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="30" cy="6" r="4" />
          <path d="M30 10 L30 20" />
          <path d="M12 44 Q12 20 30 20 Q48 20 48 44" />
          <line x1="12" y1="44" x2="48" y2="44" />
        </svg>
      </div>

      <p
        style={{
          fontFamily: "var(--font-newsreader), Georgia, serif",
          fontStyle: "italic",
          fontSize: 18,
          color: "#2C2520",
          marginTop: 24,
          opacity: 0.7,
          minHeight: "1.5em",
        }}
      >
        {text}
      </p>
    </div>
  );
}
